import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from 'wsm-skeleton';
import { setClassNames } from 'ddc-classnames-js';

const LOADING_STATE_PLACEHOLDER_CARD_COUNT = 5;

const CardInnerSkeleton = ({ isGridLayout, isTabbedLayout }) => {
	return (
		<React.Fragment>
			<div
				className={setClassNames([
					'vehicle-card-body',
					'ddc-font-size-small',
					isGridLayout ? null : 'd-sm-flex flex-sm-row' // TODO: deprecate
				])}
			>
				<div className="vehicle-card-media-container m-0">
					<Skeleton skeletonClasses="mb-4" aspectRatio="4by3" />
				</div>
				<div className="vehicle-card-details-container">
					<Skeleton
						skeletonClasses="mb-6"
						height="2rem"
						width={isTabbedLayout ? '100%' : '75%'}
					/>
					{[...Array(LOADING_STATE_PLACEHOLDER_CARD_COUNT)].map(
						(_, i) => (
							<div className="row" key={i.toString()}>
								<div className="col-xs-6">
									<Skeleton
										skeletonClasses="mb-5"
										height="1rem"
									/>
								</div>
								<div className="col-xs-6">
									<Skeleton
										skeletonClasses="mb-5"
										height="1rem"
									/>
								</div>
							</div>
						)
					)}
					{!isTabbedLayout && (
						<Skeleton
							skeletonClasses="ml-auto mt-6"
							width="48%"
							height="3rem"
						/>
					)}
				</div>
			</div>
			<div className="vehicle-card-footer p-0 mt-8">
				<Skeleton height="50px" />
			</div>
		</React.Fragment>
	);
};

CardInnerSkeleton.propTypes = {
	isGridLayout: PropTypes.bool.isRequired,
	isTabbedLayout: PropTypes.bool.isRequired
};

export default CardInnerSkeleton;
